// --- DEBUG LOGGING ---

const isDebugEnabled = () => {
  try {
    const settings = JSON.parse(localStorage.getItem("debugSettings") || "{}");
    return settings.enabled === true;
  } catch {
    return false;
  }
};

const debug = {
  log: (...args) => {
    if (isDebugEnabled()) console.log("[WorkoutAI:DEBUG]", ...args);
  },
  warn: (...args) => {
    if (isDebugEnabled()) console.warn("[WorkoutAI:DEBUG]", ...args);
  },
  error: (...args) => {
    if (isDebugEnabled()) console.error("[WorkoutAI:DEBUG]", ...args);
  },
  group: (label) => {
    if (isDebugEnabled()) console.group(`[WorkoutAI:DEBUG] ${label}`);
  },
  groupEnd: () => {
    if (isDebugEnabled()) console.groupEnd();
  },
  table: (data) => {
    if (isDebugEnabled()) console.table(data);
  },
  time: (label) => {
    if (isDebugEnabled()) console.time(`[WorkoutAI] ${label}`);
  },
  timeEnd: (label) => {
    if (isDebugEnabled()) console.timeEnd(`[WorkoutAI] ${label}`);
  },
};

export { isDebugEnabled, debug };
